export default __webpack_public_path__ + "static/media/Tallulah_9781846161896.04d74edf.jpg";